import { useQuery } from '@tanstack/react-query';
import { getOriginationWeekly } from '@/services/credit-engine.service';
import { PARTNER_ID } from '@/constants';

export function useOrigination() {
  const query = useQuery({
    queryKey: ['origination', 'weekly'],
    queryFn: () => getOriginationWeekly(PARTNER_ID),
  });
  return { weeks: query.data?.data ?? null, isLoading: query.isLoading, isError: query.isError, refetch: query.refetch };
}
